import React from "react"
import {Box, Divider, Typography} from "@mui/material";
import {DefaultComponentProps} from "@mui/types";
import CCORichText from "./CCORichText/CCORichText";
import CCORoofline from "./CCORoofline";
import {RichTextElement} from "./CCORichText/CCORichTextHelper";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    roofLine?: any,
    propertyName?: string,
    subtextPropertyName?: string,
    roofLineCharLimit?: number,
    headline?: any,
    headlineCharLimit?: number,
    type?: DefaultComponentProps<any>,
    limit?: number,
    strong?: boolean,
    subtext?: RichTextElement,
    subtextCharLimit?: number,
    subheadline?: any,
    color?: string,
    margin?: { b?: number | string, t?: number | string, l?: number | string, r?: number | string },
    justify?: string,
    background?: string,
    id?: string
    dataCypress?: string,
    metadataId?: string,
}

/**
 * This head component may be used inside full-bright elements to avoid wrapping them in CCO container multiple times
 */
function CCOHeadlineComponentHead(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return <>
        {props.roofLine ?
            <CCORoofline roofLine={props.roofLine} roofLineCharLimit={props.roofLineCharLimit} centered={true}
                         marginTop={props.margin?.t ?? undefined}/>
            :
            props.headline && props.headline.length > 0 ?
                <Box sx={{display: "flex", justifyContent: "center"}}>
                    <Divider sx={{width: 115, height: 4, mb: 4, mt: 0, bgcolor: 'primary.main'}}/>
                </Box> : null
        }

        {props.headline ?
            <Box sx={{display: "flex", justifyContent: "center"}}
                 marginBottom={!props.subtext ? props.margin?.b ?? {lg: 0, md: 0} : undefined}
                 marginLeft={!props.subtext ? props.margin?.l ?? undefined : undefined}
                 marginRight={!props.subtext ? props.margin?.r ?? undefined : undefined}


            >
                {typeof props.headline === 'string' ?
                    <Typography data-cypress={props.dataCypress} id={props.id} variant={'h2'} align="center" marginBottom={6}
                                color={props.color ?? undefined} {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}>
                        {props.headlineCharLimit ? props.headline.substring(0, props.headlineCharLimit) +
                            (props.headline.length > props.headlineCharLimit ? '...' : '') : props.headline}
                    </Typography> :
                    <Box sx={{textAlign: 'center', alignItems: 'center', marginBottom: 6}}>
                        <CCORichText metadataId={props.metadataId} data-cypress={props.dataCypress} id={props.id} textAsTree={props.headline} propertyName={props.propertyName} charLimit={props.headlineCharLimit}
                                     variant={'h2'} strong={true}/>
                    </Box>
                }
            </Box>
            : null
        }
        {props.subtext ?
            <Box sx={{display: "flex", justifyContent: "center"}}
                 marginBottom={props.margin?.b ?? undefined}
                 marginLeft={props.margin?.l ?? undefined}
                 marginRight={props.margin?.r ?? undefined}
            >
                <CCORichText metadataId={props.metadataId} propertyName={props.subtextPropertyName}
                             textAsTree={props.subtext}
                             charLimit={props.subtextCharLimit}
                             alignContent={"center"}/>
            </Box>
            : null
        }
        {props.subheadline ?
            <Box sx={{pb: 2, display: "flex", justifyContent: "center"}}>
                {typeof props.subheadline === 'string' ?
                    <Typography variant={'h5'}
                                {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}
                                gutterBottom align="center"
                                color={props.color ?? undefined}>
                        {props.headlineCharLimit ? props.subheadline.substring(0, props.headlineCharLimit) +
                            (props.subheadline.length > props.headlineCharLimit ? '...' : '') : props.subheadline} </Typography> :
                    <CCORichText metadataId={props.metadataId} textAsTree={props.subheadline} propertyName={props.subtextPropertyName} charLimit={props.headlineCharLimit} variant={'h5'}/>
                }
            </Box>
            : null
        }
    </>
}

export default CCOHeadlineComponentHead